import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginScreen from './components/LoginScreen';
import './App.css';
import AppDownload from './components/appdownload';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route path="/privacy-policy" element={<div>Chính sách quyền riêng tư</div>} />
        <Route path="/app-download" element={<AppDownload />} />
      </Routes>
    </Router>
  );
};

export default App;